module.exports = __webpack_public_path__ + "static/media/Cuboh.40ec7f37.xlsx";